<template>
  <div>
    <v-dialog persistent v-model="value" scrollable max-width="500px">
      <v-card>
        <v-form lazy-validation @submit.prevent="submit">
          <v-container fluid>
            <v-layout row class="separatorNotice" style="margin: -16px">
              <h2 class="font-weight-regular white--text separatorTittle">
                Días de asueto
              </h2>
            </v-layout>
            <v-layout wrap row>
              <v-flex
                xs12
                class="centerContent"
                style="
                  text-align: center;
                  padding-left: 10px;
                  padding-right: 10px;
                "
              >
                <v-text-field
                  label="Descripción"
                  v-model="$v.dataForm.holidayDescription.$model"
                  outline
                  :error-messages="titleErrors"
                  style="margin-top: 25px"
                />
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 style="padding-right: 15px; margin-top: -15px">
                <v-menu
                  v-model="startDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      label="Día de asueto"
                      :error-messages="dateError"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      :value="momentFormatStartDate"
                      style="width: 100%"
                    />
                  </template>
                  <v-date-picker
                    header-color="primary"
                    color="secondary"
                    v-model="$v.dataForm.holidayStrHoliday.$model"
                    @input="startDateMenu = false"
                    locale="es-419"
                  />
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 style="padding-right: 15px; margin-top: -10px">
                <v-autocomplete
                  v-model="$v.dataForm.holidayType.$model"
                  :items="dayType"
                  :item-text="typeDayText"
                  :error-messages="typeError"
                  item-value="type"
                  label="Tipo de día"
                  @change="onChanged"
                  required
                />
              </v-flex>
            </v-layout>
            <v-layout v-if="$v.dataForm.holidayType.$model === 'C'">
              <v-flex>
                <v-autocomplete
                  v-model="$v.dataForm.employee.$model"
                  :items="collaborators"
                  :item-text="collaboratorText"
                  :error-messages="employeeError"
                  item-value="id"
                  label="Colaborador"
                  required
                />
              </v-flex>
            </v-layout>
            <v-layout wrap row style="padding: 10px">
              <v-flex xs6 class="centerContent">
                <v-btn
                  small
                  color="primary"
                  @click="close"
                  :disabled="toast.loading"
                >
                  Cancelar
                </v-btn>
              </v-flex>

              <v-flex xs6 class="centerContent">
                <v-btn
                  small
                  color="primary"
                  @click="save"
                  :disabled="toast.loading"
                >
                  Confirmar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <success v-model="toast.success" text="Operación Exitosa" />
    <error v-model="toast.failed" :text="toastMesssage.failed" />
    <loading text="Trabajando..." v-model="toast.loading" />
  </div>
</template>

<script>
import moment from 'moment'

import 'vue2-timepicker/dist/VueTimepicker.css'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { getMessageError } from '../../../plugins/GeneralMethods'
import Error from '../../Dialogs/Error.vue'
import Loading from '../../Dialogs/Loading.vue'
import Success from '../../Dialogs/Success.vue'

export default {
  components: {
    Success,
    Error,
    Loading,
  },
  props: ['value'],
  validations: {
    dataForm: {
      holidayDescription: { required },
      holidayStrHoliday: { required },
      holidayType: { required },
      employee: { required },
    },
  },
  data: () => ({
    dataForm: {
      holidayDescription: '',
      holidayStrHoliday: '',
      holidayType: '',
      employee: {},
    },
    dayType: [
      {
        type: 'G',
        text: 'Global',
      },
      {
        type: 'C',
        text: 'Colaborador',
      },
    ],
    collaborators: [],
    startDateMenu: false,
    startDate: null,
    toast: {
      success: false,
      failed: false,
      loading: false,
    },
    toastMesssage: {
      failed: 'Ups ocurrió un error',
    },
  }),
  watch: {
    getBranch() {
      console.log(this.getBranch)
      if (this.getBranch.id != null) {
        this.getCollaborators()
      }
    },
  },
  mounted() {
    console.log(this.getBranch)
    if (this.getBranch.id != null) {
      this.getCollaborators()
    }
  },
  methods: {
    collaboratorText(collaborator) {
      return collaborator.firstName + ' ' + collaborator.lastName
    },
    getCollaborators() {
      const payload = {}
      payload.size = 100
      payload.offset = 0
      this.toast.loading = true

      this.$store
        .dispatch('employee/getEmployees', payload)
        .then((response) => {
          this.collaborators = response.data.data
          this.toast.loading = false
        })
        .catch((error) => {
          this.collaborators = []
          this.toast.loading = false
        })
    },
    close() {
      this.clear()
      this.$emit('input', false)
    },
    hasEmployee() {
      if (this.$v.dataForm.holidayType.$model === 'C') {
        if (
          this.$v.dataForm.employee.$model === '0' ||
          this.$v.dataForm.employee.$model === ''
        ) {
          return false
        }
      }
      return true
    },
    save() {
      this.$v.dataForm.$touch()
      if (!this.$v.dataForm.$invalid && this.hasEmployee()) {
        this.toastMesssage.failed = 'Ups ocurrió un error'
        this.toast.loading = true
        const objc = this.dataForm
        if (objc.holidayType === 'C') {
          objc.employee = { id: objc.employee }
        } else {
          objc.employee = undefined
        }
        this.$store
          .dispatch('holiday/createHoliday', objc)
          .then(() => {
            this.toast.success = true
            this.toast.loading = false
            this.clear()
            this.$emit('input', false)
            this.$emit('close')
          })
          .catch((response) => {
            this.toastMesssage.failed = getMessageError(response.data)
            this.toast.loading = false
            this.toast.failed = true
          })
      }
    },
    clear() {
      this.dataForm.holidayDescription = ''
      this.dataForm.holidayStrHoliday = ''
      this.dataForm.holidayType = ''
      this.dataForm.employee = {}
      this.$v.dataForm.holidayDescription.$reset()
      this.$v.dataForm.holidayType.$reset()
      this.$v.dataForm.holidayStrHoliday.$reset()
      this.$v.dataForm.employee.$reset()
    },
    typeDayText(data) {
      return data.text
    },
    isNullOrEmpty(value) {
      if (value === null) {
        return true
      }
      if (value === undefined) {
        return true
      }
      if (value === '') {
        return true
      }
      return false
    },
    onChanged() {
      this.dataForm.employee = '0'
    },
  },
  computed: {
    momentFormatStartDate() {
      if (!this.isNullOrEmpty(this.$v.dataForm.holidayStrHoliday.$model)) {
        return moment(this.$v.dataForm.holidayStrHoliday.$model).format(
          'DD/MM/YYYY'
        )
      }
      return ''
    },
    titleErrors() {
      const errors = []
      if (!this.$v.dataForm.holidayDescription.$dirty) return errors
      !this.$v.dataForm.holidayDescription.required &&
        errors.push('La descripción es obligatoria')
      return errors
    },
    dateError() {
      const errors = []
      if (!this.$v.dataForm.holidayStrHoliday.$dirty) return errors
      !this.$v.dataForm.holidayStrHoliday.required &&
        errors.push('La fecha es obligatoria')
      return errors
    },
    typeError() {
      const errors = []
      if (!this.$v.dataForm.holidayType.$dirty) return errors
      !this.$v.dataForm.holidayType.required &&
        errors.push('El tipo de día es obligatorio')
      return errors
    },
    employeeError() {
      const errors = []
      if (this.$v.dataForm.holidayType.$model === 'G') return errors
      if (!this.$v.dataForm.employee.$dirty) return errors
      !this.$v.dataForm.employee.required &&
        errors.push('El colaborador es obligatorio')
      this.$v.dataForm.employee.$model === '0' &&
        errors.push('El colaborador es obligatorio')
      return errors
    },
    ...mapGetters(['getBranch']),
  },
}
</script>

<style>
.separatorNotice {
  background-color: #512e6f;
  height: 60px;
}

.message {
  font-size: large;
  color: black;
}

.pickers {
  justify-content: center;
  align-items: center;
  width: 100%;
}

.date-picker-notice {
  font-size: 1.2em;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
